import type { BrandLocales } from '@/shared/i18n/types';
import ru from './ru.json';
import en from './en.json';

// Оверрайды telecom: только ключи, которые у бренда звучат иначе. Остальное —
// из базового словаря (shared/i18n/locales). Ключи обязаны существовать в
// базовом словаре и совпадать между ru и en (shared/i18n/__tests__/locales.test.ts).
const locales: BrandLocales = { ru, en };

export default locales;
